import { Suspense } from 'react';
import PropTypes from 'prop-types'
import { BounceLoader } from '@bwoty-web/styleguide';
import SkeletonLoader from '../resultList/skeletonLoader/skeletonLoader';
import './lazyLoader.scss';

const LazyLoader = ({ children, loadingAll }) => {
  if (typeof window === 'undefined' || loadingAll) { 
    return <SkeletonLoader />;
  }

  return (
    <Suspense fallback={<BounceLoader />}>
      { children }
    </Suspense>
  )
}

LazyLoader.propTypes = {
  children: PropTypes.node.isRequired,
  loadingAll: PropTypes.bool.isRequired,
}

export default LazyLoader;